import { FC, useEffect } from 'react';

import { App } from 'antd';
import enUS from 'antd/es/locale/en_US';
import plPL from 'antd/es/locale/pl_PL';

import { addLocale, getLocale } from '@umijs/max';

import { useGetDefects, useGetTranslations } from '@/services/hooks';
import { ApiLocale, UmiLocale } from '@/types';

const config = {
  'en-US': {
    antd: enUS,
    momentLocale: 'en-us',
  },
  'pl-PL': {
    antd: plPL,
    momentLocale: 'pl-pl',
  },
};

interface Props {
  children: React.ReactNode;
}

const Main: FC<Props> = ({ children }) => {
  useGetDefects();
  const { data } = useGetTranslations();
  const locale = getLocale() as UmiLocale;

  useEffect(() => {
    if (data) {
      addLocale(
        locale,
        data[locale.replace('-', '_') as ApiLocale],
        config[locale],
      );
    }
  }, [data, locale]);

  return (
    <App>
      {children}
    </App>
  );
};

export default Main;
